import { useEffect, useRef } from "react";

import { useWizard } from "@performyard/py-components";

import { STEP_ID as ADD_FORMS_STEP_ID } from "../steps/AddFormsStep/constants";

/**
 * Resets wizard progress from the Add Forms step whenever the cycle start
 * date changes, so already-validated due dates are re-validated against the
 * new start date instead of carrying stale approvals forward.
 */
export const StartDateChangeSync = ({ startDateMs }: { startDateMs: number | null }) => {
	const { resetStepsFrom, steps } = useWizard();
	const prevStartDateMsRef = useRef(startDateMs);

	useEffect(() => {
		if (prevStartDateMsRef.current === startDateMs) return;
		prevStartDateMsRef.current = startDateMs;
		const addFormsIndex = steps.findIndex((s) => s.id === ADD_FORMS_STEP_ID);
		if (addFormsIndex !== -1) {
			resetStepsFrom(addFormsIndex);
		}
	}, [startDateMs, resetStepsFrom, steps]);

	return null;
};
